module.exports = __webpack_public_path__ + "static/media/friendship.b80bab3f.jpg";